import ServerVariablesForm_vue_vue_type_script_setup_true_lang_default from "./ServerVariablesForm.vue.script.js";
//#region src/components/Server/ServerVariablesForm.vue
var ServerVariablesForm_default = ServerVariablesForm_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ServerVariablesForm_default as default };

//# sourceMappingURL=ServerVariablesForm.vue.js.map